import React from "react"
import {FieldQuickFilterViewProps} from "../../../render/quick-filter-view";
import {QUICK_FILTER_ALL_VALUES} from "../../../../gd/const/quick-filter";


export default function FieldDropdown_GroupByView(props: FieldQuickFilterViewProps) {


    const {value} = props

    let icon = null
    let label = ''


    switch (value) {
        case QUICK_FILTER_ALL_VALUES:
            label = 'All values'
            break
        case null:
        case 'null':
            label = 'Not selected'
            break

        default:
            const option = props.field._getOption(value)
            if (option) {
                const optionColor = _.get(option, 'color', null);

                if (optionColor) {
                    icon = optionColor && <div className={Classes("icon m-r-10", "ui5-circle", "s8", "gd-c-bgp-"+optionColor, "gd-c-pale-border-"+optionColor)}/>
                }
                label = option.label
            } else {
                label = value
            }
    }


    return (
        <div className="ui5-group-by-view">
            {icon}
            <div className="name">{label}</div>
        </div>
    )


}